import React from 'react';
import './progressBar.css'

interface ProgressBar {
    loadPercentage: number;
  }

const ProgressBar: React.FC<ProgressBar> =({loadPercentage}) => {
  return (
    <div className="progressContainer">
      {/* <h3>Progreso de Carga</h3> */}
      <div className="progress">
        <div
          className="progress-bar"
          role="progressbar"
          style={{ width: loadPercentage+'%', backgroundColor:"#3cb5e6"}}
          aria-valuenow={loadPercentage}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          {loadPercentage}%
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
